import React from 'react'
import { Switch } from 'react-router-dom'

import { PermissionRoute } from '../../common/components/routes'
import { APP_ROUTES, PERMISSIONS } from '../../common/constants'

import { DictionaryWordsPage } from './pages'

const DictionaryWordsRouter = () => (
  <Switch>
    <PermissionRoute
      exact
      path={APP_ROUTES.DICTIONARY_WORDS.link}
      permissions={[PERMISSIONS.DICTIONARY_WORD.LIST]}
      component={DictionaryWordsPage}
    />
  </Switch>
)

export default DictionaryWordsRouter
